import { useCallback } from 'react';
import { Box, Stack, Typography, useTheme, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useForgotPassword } from 'hooks/useForgotPassword';
import { UserWorkspaceProfile } from 'models/UserWorkspaceProfile';

const StyledPasswordTypography = styled(Typography)({
    fontWeight: 'bold',
});

const ChangePasswordButton = styled(LoadingButton)(({ theme }) => ({
    marginLeft: 'auto',
    flexShrink: 0,
    borderRadius: '20px',
    width: '10rem',
    height: '40px',
}));

export const MobileLogingInSection = (props: { user: UserWorkspaceProfile }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { user } = props;
    const { processForgotPassword, forgotPasswordPending } = useForgotPassword();

    const handleChangePassword = useCallback(() => {
        processForgotPassword({ email: user.email });
    }, [processForgotPassword, user.email]);

    return (
        <Box padding={theme.spacing(2)}>
            <Stack direction="row" alignItems="center">
                <StyledPasswordTypography>{t('general.password')}</StyledPasswordTypography>
                <ChangePasswordButton
                    loading={forgotPasswordPending}
                    disabled={!user.emailConfirmed}
                    variant="contained"
                    color="primary"
                    onClick={handleChangePassword}
                >
                    {t('profile.changePassword')}
                </ChangePasswordButton>
            </Stack>
        </Box>
    );
};
